export default "__VITE_ASSET__Cr65ro8E__"